/**
 * @file Saga removing one contract: a 200 or 207 removes the store row, a 200 snackbars and a 207 opens the delete's partial dialog.
 * Failure path: catch → ErrorHandlerSequence with the route's expected errors.
 */
import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence, ExpectedErrors } from "../Sequences/ErrorHandlerSequence";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ContractInterface } from "../../Entity/Entities/Contract/ContractInterface";
import Translator from "../../Translation/Translator";
import Http from "../../Http/Http";

const EXPECTED_ERRORS: ExpectedErrors = {
  financial_operations_were_blocked: { titleKey: "refusal-title-contract-remove", bodyKey: "refusal-body-financial-processing-busy" },
  be_contract_not_found: { titleKey: "refusal-title-contract-remove", bodyKey: "refusal-body-contract-remove-not-found" },
  be_server_error: { titleKey: "refusal-title-contract-remove", bodyKey: "refusal-body-contract-remove-server-error" },
  payout_charge_remove_forbidden: { titleKey: "refusal-title-contract-remove", bodyKey: "refusal-body-contract-remove-payout-charge" },
  cannot_unlink_payment_because_financial_statement_locked: { titleKey: "refusal-title-contract-remove", bodyKey: "refusal-body-contract-remove-locked-statement" },
  cannot_remove_credit_charge: { titleKey: "refusal-title-contract-remove", bodyKey: "refusal-body-contract-remove-credit-charge" },
  cannot_remove_special_settlement_payment: { titleKey: "refusal-title-contract-remove", bodyKey: "refusal-body-contract-remove-settlement-payment" },
  impossible_link_removed_items: { titleKey: "refusal-title-contract-remove", bodyKey: "refusal-body-contract-remove-link-gone" },
  cannot_remove_finished_contract: { titleKey: "refusal-title-contract-remove", bodyKey: "cannot_remove_finished_contract" },
  cannot_remove_contract_with_locked_charges: { titleKey: "refusal-title-contract-remove", bodyKey: "cannot_remove_contract_with_locked_charges" },
  be_contract_remove_failed: { titleKey: "refusal-title-contract-remove", bodyKey: "be_contract_remove_failed" }
};

export default function* contractDelete(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_CONTRACT_DELETE_REQUEST
    });

    const res = yield call(Http.delete, `contract/${action.payload?.contract.id}`);

    const contract: ContractInterface = action.payload?.contract.reinitialize({
      removed: true
    });

    yield put({
      type: Constants.GLOBAL_CONTRACT_DELETE_SUCCESS,
      payload: {
        contract: contract
      }
    });

    if (res.status === 207) {
      yield put({
        type: Constants.GLOBAL_REFUSAL_DIALOG_OPEN,
        payload: {
          titleKey: "partial-title-contract-remove",
          bodyKey: "partial-body-contract-remove"
        }
      });
    } else {
      yield put({
        type: Constants.SNACKBAR_ADD_MESSAGE,
        payload: {
          message: Translator.trans(action.payload?.contract.isConcept || action.payload?.contract.isDropped ?
            "snackbar-message-contract-removed-successfully" :
            "snackbar-message-contract-removed-with-charges"),
          type: "success"
        }
      });
    }

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this);
    }

  } catch (err) {

    yield ErrorHandlerSequence(err, action, EXPECTED_ERRORS);

  }
}

export function* watchContractDelete() {
  yield takeEvery(Constants.GLOBAL_CONTRACT_DELETE_START, contractDelete);
}
